export enum EnumType {
  TYPUCTU,
  STRANAZUSTATKU,
  TYPFORMATU
}

// export enum TypUctu{
//     A = "A",
//     AK = "AK",
//     AP = "AP",
//     N = "N",
//     P = "P",
//     V = "V",
//     PR = "PR",
//     ZZ = "ZZ",
//     O = "O"
// }

export enum TypUctu{
    'A - Účet aktivní' ,
    'AK - Účet korekcí aktiv',
    'AP - Účet aktivní / pasivní',
    'N - Účet nákladový',
    'P - Účet pasivní',
    'V - Účet výnosů',
    'PR - Účet podrozvahový',
    'ZZ - Závěrkové a zvláštní',
    'O - Ostatní'
}

export enum StranaZustatku{
    'MD - Má dáti',
    'D - Dal',
    'O - Oboje',
    'K - Konečné stavy',
    'S - Spojovací účty'
}

export enum TypFormatu
{
  xml= "xml",
  pdf= "pdf",
  html= "html",
  xlsx= "xlsx",
  scriban_html= "scriban-html"
}

